(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    var PG_SWIPER_JS = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.1.14/swiper-bundle.min.js';

  var PG_SWIPER_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.1.14/swiper-bundle.min.css';

  var pgSwiperPromise = null;

  /* ============================================================
     LOAD SWIPER CSS
  ============================================================ */

  function pgEnsureSwiperCss() {
    if (!document.querySelector('link[data-pg-swiper-css]')) {
      var link = document.createElement('link');

      link.rel = 'stylesheet';

      link.href = PG_SWIPER_CSS;

      link.setAttribute('data-pg-swiper-css', '');

      document.head.appendChild(link);
    }
  }

  /* ============================================================
     LOAD SWIPER
  ============================================================ */

  function pgLoadSwiper() {
    if (window.Swiper) {
      return Promise.resolve();
    }

    if (pgSwiperPromise) {
      return pgSwiperPromise;
    }

    pgEnsureSwiperCss();

    pgSwiperPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');

      script.src = PG_SWIPER_JS;

      script.onload = resolve;

      script.onerror = reject;

      document.head.appendChild(script);
    });

    return pgSwiperPromise;
  }

  /* ============================================================
     CUSTOM ELEMENT
  ============================================================ */

  class PgGallery extends HTMLElement {
    connectedCallback() {
      this.mainEl = this.querySelector('[data-pg-main]');

      this.thumbsEl = this.querySelector('[data-pg-thumbs]');

      this.thumbsPrevEl = this.querySelector('[data-pg-thumbs-prev]');

      this.thumbsNextEl = this.querySelector('[data-pg-thumbs-next]');

      this.lightbox = this.querySelector('[data-pg-lightbox]');

      this.lightboxImage = this.querySelector('[data-pg-lightbox-image]');

      this.lightboxThumbs = Array.prototype.slice.call(this.querySelectorAll('[data-pg-lightbox-thumb]'));

      this.lightboxOpeners = Array.prototype.slice.call(this.querySelectorAll('[data-pg-lightbox-open]'));

      this.currentLightboxIndex = 0;

      this.previousBodyOverflow = '';

      if (!this.mainEl) {
        return;
      }

      this.bindLightbox();

      pgLoadSwiper()
        .then(() => this.buildSwiper())

        .catch(() => this.buildFallback());
    }

    /* ============================================================
       SWIPER
    ============================================================ */

    buildSwiper() {
      if (this.inited) {
        return;
      }

      if (!window.Swiper) {
        this.buildFallback();

        return;
      }

      this.inited = true;

      var gap = parseInt(this.dataset.thumbGap || '16', 10);

      var mobileThumbGap = 8;

      var thumbs = null;

      if (this.thumbsEl) {
        var thumbsConfig = {
          slidesPerView: 'auto',

          /*
            Mobile always gets a fixed 8px gap regardless of the
            merchant's configured gap setting. The breakpoint below
            switches to the configured gap at 750px and up. Swiper
            handles this live on resize, no extra JS needed.
          */
          spaceBetween: mobileThumbGap,

          watchSlidesProgress: true,

          slideToClickedSlide: true,

          observer: true,

          observeParents: true,

          breakpoints: {
            750: {
              spaceBetween: gap,
            },
          },
        };

        if (this.thumbsPrevEl && this.thumbsNextEl) {
          thumbsConfig.navigation = {
            prevEl: this.thumbsPrevEl,

            nextEl: this.thumbsNextEl,
          };
        }

        thumbs = new Swiper(this.thumbsEl, thumbsConfig);
      }

      this.mainSwiper = new Swiper(this.mainEl, {
        slidesPerView: 1,

        spaceBetween: 0,

        observer: true,

        observeParents: true,

        thumbs: thumbs
          ? {
              swiper: thumbs,
            }
          : undefined,
      });

      this.thumbsSwiper = thumbs;

      /*
        By default Swiper's Thumbs module only updates the main
        image when a thumbnail is clicked/tapped — dragging the
        thumbnail strip does not push a change to the main slider.
        This listener makes the main image follow whichever
        thumbnail becomes active, whether that happens via click
        or via swipe/drag.
      */

      if (thumbs) {
        var self = this;

        thumbs.on('slideChange', function () {
          if (!self.mainSwiper) {
            return;
          }

          if (self.mainSwiper.activeIndex !== thumbs.activeIndex) {
            self.mainSwiper.slideTo(thumbs.activeIndex);
          }
        });
      }
    }

    /* ============================================================
       FALLBACK
    ============================================================ */

    buildFallback() {
      if (this.inited) {
        return;
      }

      this.inited = true;

      this.classList.add('pg--no-swiper');

      var mainImg = this.querySelector('.pg__main-swiper .swiper-slide .pg__main-img');

      var thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-pg-thumb]'));

      if (thumbs[0]) {
        thumbs[0].classList.add('is-active');
      }

      thumbs.forEach(function (thumb) {
        var swap = function () {
          if (mainImg) {
            mainImg.removeAttribute('srcset');

            mainImg.src = thumb.dataset.full;

            if (thumb.dataset.srcset) {
              mainImg.srcset = thumb.dataset.srcset;
            }

            if (thumb.dataset.alt) {
              mainImg.alt = thumb.dataset.alt;
            }
          }

          thumbs.forEach(function (other) {
            other.classList.remove('is-active');
          });

          thumb.classList.add('is-active');
        };

        thumb.addEventListener('click', swap);

        thumb.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();

            swap();
          }
        });
      });
    }

    /* ============================================================
       LIGHTBOX
    ============================================================ */

    bindLightbox() {
      if (!this.lightbox || !this.lightboxImage) {
        return;
      }

      var self = this;

      this.lightboxOpeners.forEach(function (opener) {
        opener.addEventListener('click', function () {
          self.openLightbox(parseInt(opener.dataset.index || '0', 10));
        });
      });

      this.lightboxThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          self.showLightboxImage(parseInt(thumb.dataset.index || '0', 10));
        });
      });

      this.querySelectorAll('[data-pg-lightbox-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          self.closeLightbox();
        });
      });

      var prev = this.querySelector('[data-pg-lightbox-prev]');

      var next = this.querySelector('[data-pg-lightbox-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          self.moveLightbox(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          self.moveLightbox(1);
        });
      }

      this._pgKeyHandler = function (event) {
        if (self.lightbox.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          self.closeLightbox();
        }

        if (event.key === 'ArrowLeft') {
          self.moveLightbox(-1);
        }

        if (event.key === 'ArrowRight') {
          self.moveLightbox(1);
        }
      };

      document.addEventListener('keydown', this._pgKeyHandler);
    }

    openLightbox(index) {
      if (!this.lightbox) {
        return;
      }

      this.showLightboxImage(index);

      this.previousBodyOverflow = document.body.style.overflow;

      document.body.style.overflow = 'hidden';

      this.lightbox.hidden = false;

      this.lightbox.setAttribute('aria-hidden', 'false');

      var close = this.querySelector('.pg__lightbox-close');

      if (close) {
        close.focus();
      }
    }

    closeLightbox() {
      if (!this.lightbox) {
        return;
      }

      this.lightbox.hidden = true;

      this.lightbox.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = this.previousBodyOverflow || '';
    }

    showLightboxImage(index) {
      if (!this.lightboxThumbs.length) {
        var opener = this.lightboxOpeners[index];

        if (opener) {
          var img = opener.querySelector('img');

          if (img) {
            this.lightboxImage.src = img.currentSrc || img.src;

            this.lightboxImage.alt = img.alt || '';
          }
        }

        return;
      }

      if (index < 0) {
        index = this.lightboxThumbs.length - 1;
      }

      if (index >= this.lightboxThumbs.length) {
        index = 0;
      }

      this.currentLightboxIndex = index;

      var thumb = this.lightboxThumbs[index];

      this.lightboxImage.src = thumb.dataset.full;

      this.lightboxImage.alt = thumb.dataset.alt || '';

      this.lightboxThumbs.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });

      var counter = this.querySelector('[data-pg-lightbox-current]');

      if (counter) {
        counter.textContent = String(index + 1);
      }

      thumb.scrollIntoView({
        behavior: 'smooth',

        block: 'nearest',

        inline: 'center',
      });
    }

    moveLightbox(direction) {
      if (!this.lightboxThumbs.length) {
        return;
      }

      this.showLightboxImage(this.currentLightboxIndex + direction);
    }

    /* ============================================================
       CLEANUP
    ============================================================ */

    disconnectedCallback() {
      if (this.mainSwiper && this.mainSwiper.destroy) {
        this.mainSwiper.destroy(true, true);
      }

      if (this.thumbsSwiper && this.thumbsSwiper.destroy) {
        this.thumbsSwiper.destroy(true, true);
      }

      if (this._pgKeyHandler) {
        document.removeEventListener('keydown', this._pgKeyHandler);
      }

      if (this.lightbox && !this.lightbox.hidden) {
        document.body.style.overflow = this.previousBodyOverflow || '';
      }

      this.inited = false;
    }
  }

  /* ============================================================
     REGISTER
  ============================================================ */

  if (!customElements.get('pg-gallery')) {
    customElements.define('pg-gallery', PgGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-pincode"] && !Shopify.designMode) return;
  try {
    class PincodeChecker extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-pin]');
      this.btn = this.querySelector('[data-check]');
      this.result = this.querySelector('[data-result]');

      if (!this.input || !this.btn || !this.result) return;

      this.btn.addEventListener('click', () => this.check());

      this.input.addEventListener('input', () => {
        this.input.value = this.input.value
          .replace(/\D/g, '')
          .slice(0, 6);
      });

      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.check();
        }
      });
    }

    async check() {
      const val =
        (this.input.value || '').trim();

      this.result.hidden = false;

      /* -----------------------------------------
         Validate pincode
      ------------------------------------------ */

      if (!/^\d{6}$/.test(val)) {
        this.result.dataset.state = 'err';

        this.result.textContent =
          this.dataset.err ||
          'Please enter a valid 6-digit pincode';

        return;
      }

      const originalButtonText =
        this.btn.textContent;

      this.btn.disabled = true;
      this.btn.textContent = 'Checking...';

      this.result.dataset.state = '';
      this.result.textContent =
        'Checking delivery availability...';

      try {
        const response = await fetch(
          'https://deckface-delivery-api.onrender.com/delivery-check',
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              pincode: val
            })
          }
        );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data?.message ||
            'Unable to check delivery'
          );
        }

        /* -----------------------------------------
           Serviceable
        ------------------------------------------ */

        if (data.serviceable) {
          this.result.dataset.state = 'ok';

          if (data.estimatedDays) {
            this.result.textContent =
              `✓ Delivery available to ${val} in ${data.estimatedDays} days`;
          } else {
            this.result.textContent =
              `✓ Delivery available to ${val}`;
          }

          return;
        }

        /* -----------------------------------------
           Not serviceable
        ------------------------------------------ */

        this.result.dataset.state = 'err';

        this.result.textContent =
          `Sorry, delivery is currently unavailable to ${val}`;

      } catch (error) {
        console.error(
          '[PincodeChecker]',
          error
        );

        this.result.dataset.state = 'err';

        this.result.textContent =
          'Unable to check delivery right now. Please try again.';

      } finally {
        this.btn.disabled = false;

        this.btn.textContent =
          originalButtonText;
      }
    }
  }

  if (!customElements.get('pincode-checker')) {
    customElements.define(
      'pincode-checker',
      PincodeChecker
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-trust-badges"] && !Shopify.designMode) return;
  try {
    class TrustBadges extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var badges = this.querySelectorAll('.pbx-badge');
      if (!badges.length) return;

      var designMode = this.dataset.designMode === 'true';
      var loop = this.dataset.playback === 'loop';
      var KEY = 'pbx-badges-animated';

      // "once" playback is gated to the first visit; "loop" always runs.
      if (!loop && !designMode) {
        var seen = false;
        try {
          seen = localStorage.getItem(KEY) === '1';
        } catch (e) {}
        if (seen) return;
      }

      var stagger = parseInt(this.dataset.stagger || '0', 10);
      for (var i = 0; i < badges.length; i++) {
        badges[i].style.setProperty('--pbx-delay', i * stagger + 'ms');
      }
      this.classList.add('pbx--prep');
      if (loop) this.classList.add('pbx--loop');

      var self = this;
      var play = function () {
        self.classList.add('pbx--animate');
        if (!loop && !designMode) {
          try {
            localStorage.setItem(KEY, '1');
          } catch (e) {}
        }
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                play();
                io.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );
        io.observe(this);
      } else {
        play();
      }
    }
  }
  if (!customElements.get('trust-badges')) {
    customElements.define('trust-badges', TrustBadges);
  }
  } catch(e) { console.error(e); }
})();

})();
